// extracted by mini-css-extract-plugin
export default {"disclaimerLabel":"vE30lKTOMKj27c291cUc","instructionsAlert":"JfE7BX1rhTpwBp6owVBL","drawInstructions":"Q_oFShe41zDh0FaV73Km","buttonFooter":"BUFMBvsDB_fwZvvoyf5G"};